var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConectedBand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11474",
    "data-name": "Group 11474",
    transform: "translate(-20.087 -91.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M-2545.16,531.975a7.255,7.255,0,0,1,.964-2.3,5.5,5.5,0,0,1,5.726-2.281,5.486,5.486,0,0,1,4.2,4.387,7.222,7.222,0,0,1-.805,4.407,18.53,18.53,0,0,1-4.386,5.652,35.991,35.991,0,0,1-5.4,4.038c-.148.092-.265.165-.459.043a32.073,32.073,0,0,1-7.442-6.115,13.949,13.949,0,0,1-3.026-5.241,5.544,5.544,0,0,1,2.509-6.593,5.482,5.482,0,0,1,8.084,3.806C-2545.184,531.846-2545.172,531.911-2545.16,531.975Z",
    transform: "translate(2587.704 -422.281)",
    fill: "#7886f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M157.5,164a21,21,0,1,1,17.018-33.307A20.678,20.678,0,0,1,178.5,143",
    transform: "translate(-114.913 -29.247)",
    fill: "none",
    stroke: "#ea248c",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectedBand);
export default __webpack_public_path__ + "static/media/conected_band.e10ece852d05b8192117ccd03a72e71f.svg";
export { ForwardRef as ReactComponent };